import { render, staticRenderFns } from "./ProjectSettingsSegments.vue?vue&type=template&id=26d58470"
import script from "./ProjectSettingsSegments.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsSegments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports